import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[numberDirective]'
})
export class NumberDirective {
  private readonly allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
    'Enter',
    '.'
  ];

  constructor(private elementRef: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === ' ' || event.code === 'Space') {
      event.preventDefault();
      return;
    }

    if (this.isAllowedKey(event)) {
      if (event.key === '.' && this.elementRef.nativeElement.value.includes('.')) {
        event.preventDefault();
      }
      return;
    }

    if (this.isShortcutKey(event)) return;
    if (this.isValidNumberInput(event)) return;

    event.preventDefault();
  }

  private isAllowedKey(event: KeyboardEvent): boolean {
    return this.allowedKeys.includes(event.key);
  }

  private isShortcutKey(event: KeyboardEvent): boolean {
    return (event.ctrlKey || event.metaKey) && ['c', 'v', 'x'].includes(event.key.toLowerCase());
  }

  private isValidNumberInput(event: KeyboardEvent): boolean {
    if (event.key === '-' && this.elementRef.nativeElement.value.length > 0) {
      return false;
    }
    return !isNaN(Number(event.key));
  }
}
